/**
 * Truy cập màn Soạn thảo văn bản của module `van-ban` (`/api/v1/m/van-ban/compose*` qua Gateway,
 * ADR-0084). Chọn API thật hay dữ liệu mẫu bằng `dungApiThat()` lúc gọi.
 *
 * Bản giả ghép văn bản ở client bằng cùng khung NĐ30 của màn Xem mẫu, để màn hình chạy đúng luồng
 * khi không có backend.
 */
import { dungApiThat, goiApi } from '../api/http';
import { MOCK_CAU_TOM_TAT as CAU } from '../../mock/van-ban-tom-tat';
import { mockRequest } from '../../mock/transport';
import { phanDau, phanKy } from '../../modules/xu-ly-van-ban/nghiep-vu/khung-van-ban';
import { tuTheThucMau } from '../../modules/xu-ly-van-ban/nghiep-vu/mau-van-ban';
import type {
  ChuTrichTuTep,
  KetQuaDienTruong,
  KetQuaSoan,
  YeuCauSoan,
} from '../../modules/xu-ly-van-ban/types-tom-tat';

const GOC = '/api/v1/m/van-ban';
const TOKEN_GIA = { input: 0, output: 0, total: 0 };

const banGia = {
  soan: (vao: YeuCauSoan): Promise<KetQuaSoan> => {
    const info = tuTheThucMau({ ...vao, noinhan: vao.noinhan });
    return mockRequest({
      html: phanDau(CAU.tenMauGia, '', info) + CAU.soanGia + phanKy(info),
      template_name: '',
      values: vao.values ?? null,
      missing_keys: null,
      token_usage: TOKEN_GIA,
    });
  },
  dienTruong: (vao: { template_id: string; source_content: string; keys: string[] }): Promise<KetQuaDienTruong> =>
    mockRequest({
      template_name: '',
      values: Object.fromEntries(vao.keys.map((k) => [k, CAU.hoTenGia])),
      manual_fields: [],
      token_usage: TOKEN_GIA,
    }),
  trichChu: async (tep: File): Promise<ChuTrichTuTep> => {
    const text = await tep.text();
    return mockRequest({ text, filename: tep.name, char_count: [...text].length });
  },
};

const banThat: typeof banGia = {
  soan: (vao) => goiApi<KetQuaSoan>(`${GOC}/compose`, { method: 'POST', body: vao }),
  dienTruong: ({ template_id, source_content }) =>
    goiApi<KetQuaDienTruong>(`${GOC}/compose/fill`, { method: 'POST', body: { template_id, source_content } }),
  trichChu: (tep) => {
    const form = new FormData();
    form.append('file', tep);
    return goiApi<ChuTrichTuTep>(`${GOC}/compose/extract-text`, { method: 'POST', bieuMau: form });
  },
};

const chon = () => (dungApiThat() ? banThat : banGia);

export const soanThaoRepository = {
  soan: (vao: YeuCauSoan) => chon().soan(vao),
  /** `keys` chỉ dùng ở bản giả (biết trường nào cần điền); bản thật đọc từ mẫu ở backend. */
  dienTruong: (vao: { template_id: string; source_content: string; keys: string[] }) => chon().dienTruong(vao),
  trichChu: (tep: File) => chon().trichChu(tep),
};
